import { EMAIL_REGEX } from '@/utils/emailValidation';

export const STATUS_COLORS = {
  success: { bg: 'success-300', icon: '255, 255, 255', text: 'base-white' },
  error: { bg: 'error-200', icon: '255, 255, 255', text: 'base-white' },
  info: { bg: 'pastel-6-light', icon: '77, 15, 0', text: 'pastel-6-dark' },
  warning: { bg: '#FFF2CC', icon: '242, 153, 74', text: 'base-white' },
  message: { bg: 'secondary-950', icon: '255, 255, 255', text: 'base-white' },
};
export const TOAST_BORDERS = {
  success: 'success-200',
  error: 'error-100',
  info: 'warning-100',
  message: 'secondary-950',
};

export const REGEX_PATTERNS = {
  email: EMAIL_REGEX,
  linkedin:
    /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company)\/[^\s/?#]+(\/)?$/,
  github: /^https?:\/\/(www\.)?github\.com\/[a-zA-Z0-9-_]+\/?(\?.*)?$/,
  facebook: /^https?:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?(\?.*)?$/,
  twitter:
    /^https?:\/\/(www\.)?(twitter\.com|x\.com)\/[a-zA-Z0-9_]+\/?(\?.*)?$/,
  instagram: /^https?:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9._]+\/?(\?.*)?$/,
  stackoverflow:
    /^https?:\/\/(www\.)?stackoverflow\.com\/users\/\d+\/[a-zA-Z0-9_-]+\/?(\?.*)?$/,
  website: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/[^\s]*)?$/,
  genericUrl: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/[^\s]*)?$/,
};

export const CALENDAR_PROVIDERS = {
  GOOGLE: 'gcal',
  MICROSOFT: 'mscal',
};

export const ATS_MILESTONES = {
  LEAD: 'Lead',
  APPLIED: 'Applied',
  INTERVIEW: 'Interview',
  OFFER: 'Offer',
  HIRED: 'Hired',
};

export const INTERVIEW_PLAN_MILESTONES_ORDER = [
  ATS_MILESTONES.LEAD,
  ATS_MILESTONES.APPLIED,
  ATS_MILESTONES.INTERVIEW,
  ATS_MILESTONES.OFFER,
  ATS_MILESTONES.HIRED,
];

export const CUSTOM_FIELDS = {
  TEXT: 'TEXT',
  CHOICES: 'CHOICES',
  EVALUATION: 'EVALUATION',
  DATE: 'DATE',
  MISC: 'MISC',
};

export const CUSTOM_FIELD_CATEGORIES = [
  CUSTOM_FIELDS?.TEXT,
  CUSTOM_FIELDS?.CHOICES,
  CUSTOM_FIELDS?.EVALUATION,
  CUSTOM_FIELDS?.DATE,
  CUSTOM_FIELDS?.MISC,
];

export const EXTERNAL_MEETING_LOCATION = ['hackerrank'];
